import { createFeatureSelector, createSelector } from '@ngrx/store';
import { GeoState } from '../model/geo.model';

export const selectGeoFeature = createFeatureSelector<GeoState>('geo');

export const selectGeoState = createSelector(
  selectGeoFeature,
  (state: GeoState) => state
);

export const selectIsRegulated = createSelector(
  selectGeoFeature,
  (state: GeoState) => state.isRegulated
);

export const selectGeoLoading = createSelector(
  selectGeoFeature,
  (state: GeoState) => state.loading
);

export const selectGeoError = createSelector(
  selectGeoFeature,
  (state: GeoState) => state.error
);